var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 0.25H9.5C9.0875 0.25 8.75 0.5875 8.75 1C8.75 1.4125 9.0875 1.75 9.5 1.75H11.75C12.9875 1.75 14 2.7625 14 4C14 5.2375 12.9875 6.25 11.75 6.25H9.5C9.0875 6.25 8.75 6.5875 8.75 7C8.75 7.4125 9.0875 7.75 9.5 7.75H11.75C13.82 7.75 15.5 6.07 15.5 4C15.5 1.93 13.82 0.25 11.75 0.25ZM5 4C5 4.4125 5.3375 4.75 5.75 4.75H10.25C10.6625 4.75 11 4.4125 11 4C11 3.5875 10.6625 3.25 10.25 3.25H5.75C5.3375 3.25 5 3.5875 5 4ZM6.5 6.25H4.25C3.0125 6.25 2 5.2375 2 4C2 2.7625 3.0125 1.75 4.25 1.75H6.5C6.9125 1.75 7.25 1.4125 7.25 1C7.25 0.5875 6.9125 0.25 6.5 0.25H4.25C2.18 0.25 0.5 1.93 0.5 4C0.5 6.07 2.18 7.75 4.25 7.75H6.5C6.9125 7.75 7.25 7.4125 7.25 7C7.25 6.5875 6.9125 6.25 6.5 6.25Z",
    fill: "#094063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.3c522e69e31f7d770245e97ae37497e5.svg";
export { ForwardRef as ReactComponent };